import React, { useState } from "react";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { LANG } from "../../../constants/language";
import { WebPage } from "../../../types/webpage";
import { useSelector } from "react-redux";
import {
  ApplicationPageSelector,
  FooterPageSelector,
  HomePageSelector,
} from "../../../core/data/redux/webpage/webPageAction";
import { useFormik } from "formik";
import { subscribeNewsLetter } from "../../../services/user.service";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { alphaOnly } from "../../../utils";
import clsx from "clsx";
import ErrorText from "../../../core/components/error-text";

const subscribeSchema = Yup.object().shape({
  firstName: Yup.string().required(LANG.FIRSTNAME_IS_REQUIRED),
  lastName: Yup.string().required(LANG.LASTNAME_IS_REQUIRED),
  email: Yup.string()
    .email(LANG.PLEASE_ADD_VALID_EMAIL)
    .required(LANG.EMAIL_IS_REQUIRED),
});

const HomeSubscribe = () => {
  const footerpage: WebPage = useSelector(FooterPageSelector);
  const application: WebPage = useSelector(ApplicationPageSelector);

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
  };
  const [loading, setLoading] = useState<boolean>(false);

  const formik = useFormik({
    initialValues,
    validationSchema: subscribeSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setLoading(true);
      try {
        const result = await subscribeNewsLetter(values);
        if (result.status == 200) {
          toast.success(LANG.SUBSCRIBE_EMAIL_SUCCESSFULLY);
          resetForm();
        }
        setSubmitting(false);
        setLoading(false);
      } catch (error) {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.responseMessage);
        }
        setSubmitting(false);
        setLoading(false);
      }
    },
  });
  return (
    <section className="subscribeSection">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="appDownload">
              <label>{LANG.DOWNLOAD_THE_APP}:</label>
              <div className="btns">
                <Link
                  to={
                    application?.application?.iosLink ||
                    "https://www.apple.com/in/app-store/"
                  }
                  target="_blank"
                >
                  <img src={"/assets/img/ios.png"} alt="ios" />
                </Link>
                <Link
                  to={
                    application?.application?.androidLink ||
                    "https://play.google.com/store/apps"
                  }
                  target="_blank"
                >
                  <img
                    src={"/assets/img/android.png"}
                    style={{ height: 61 }}
                    alt="android"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="subscribeFormWrap">
              <h3 className="mb-3 fw-bold">
                {footerpage?.footer?.title}
              </h3>
              {/* <div className="d-flex">
                  <div className="col-lg-7 col-sm-12">
                    <p className="text-gray" style={{ color: "#666666" }}>
                      {LANG.BECOME_PART_OF_THE_CLUB_SUBTITLE}
                    </p>
                  </div>
                  <div className="col-lg-5 col-sm-12">
                    <Link to={"/auth/register"}>
                      <button type="button" className="w-100">
                        {LANG.JOIN_NOW}
                      </button>
                    </Link>
                  </div>
                </div> */}
              <form onSubmit={formik.handleSubmit}>
                <div className="row my-4">
                  <div className="col-lg-6 row">
                    <div className="col-lg-6 form-group">
                      <div className="group-img">
                        <input
                          type="text"
                          placeholder={LANG.FIRST_NAME}
                          maxLength={64}
                          onKeyPress={alphaOnly}
                          {...formik.getFieldProps("firstName")}
                          className={clsx("form-control commonInput", {
                            "border border-danger":
                              formik.touched.firstName &&
                              formik.errors.firstName,
                          })}
                        />
                      </div>
                      <ErrorText
                        show={
                          formik.touched.firstName && formik.errors.firstName
                        }
                        message={formik.errors?.firstName}
                      />
                    </div>
                    <div className="col-lg-6 form-group mb-2">
                      <div className="group-img">
                        <input
                          type="text"
                          placeholder={LANG.LAST_NAME}
                          maxLength={64}
                          onKeyPress={alphaOnly}
                          {...formik.getFieldProps("lastName")}
                          className={clsx("form-control commonInput", {
                            "border border-danger":
                              formik.touched.lastName && formik.errors.lastName,
                          })}
                        />
                      </div>
                      <ErrorText
                        show={formik.touched.lastName && formik.errors.lastName}
                        message={formik.errors?.lastName}
                      />
                    </div>

                    <div className="col-lg-12 form-group">
                      <input
                        placeholder={LANG.ENTER_EMAIL_ADDRESS}
                        {...formik.getFieldProps("email")}
                        className={clsx(
                          "form-control commonInput bg-transparent",
                          {
                            "border border-danger":
                              formik.touched.email && formik.errors.email,
                          }
                        )}
                        type="email"
                      />
                      <ErrorText
                        show={formik.touched.email && formik.errors.email}
                        message={formik.errors?.email}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 my-2">
                    <button
                      className="btn btn-primary mx-3"
                      disabled={loading}
                      type="submit"
                    >
                      {LANG.SUBSCRIBE}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeSubscribe;
